import { User, Sparkles } from 'lucide-react';

interface InstructorBiosProps {
  section: any;
}

export default function InstructorBios({ section }: InstructorBiosProps) {
  const instructors: any[] = section.content?.instructors ?? [];
  const headingId = `instructors-heading-${section.id}`;

  if (instructors.length === 0) return null;

  return (
    <section aria-labelledby={headingId} className="bg-cream">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          {section.title && (
            <h2
              id={headingId}
              className="font-display text-3xl font-bold text-sage-900 sm:text-4xl"
            >
              {section.title}
            </h2>
          )}
          {section.subtitle && (
            <p className="mt-2 text-sage-600 max-w-xl mx-auto">
              {section.subtitle}
            </p>
          )}
          <div className="mt-4 flex items-center justify-center gap-3" aria-hidden="true">
            <div className="h-px w-12 bg-sage-300" />
            <Sparkles className="h-4 w-4 text-sage-400" />
            <div className="h-px w-12 bg-sage-300" />
          </div>
        </div>

        {/* Instructor cards */}
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {instructors.map((instructor: any, i: number) => (
            <div
              key={i}
              className="rounded-xl bg-surface p-6 shadow-sm border border-sage-100 text-center"
            >
              {/* Avatar */}
              <div className="mx-auto mb-4 h-24 w-24 overflow-hidden rounded-full bg-sage-50 flex items-center justify-center">
                {instructor.imageUrl ? (
                  <img
                    src={instructor.imageUrl}
                    alt={instructor.name}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <User className="h-10 w-10 text-sage-300" aria-hidden="true" />
                )}
              </div>

              <h3 className="font-display text-lg font-semibold text-sage-900">
                {instructor.name}
              </h3>
              {instructor.title && (
                <p className="mt-0.5 text-sm font-medium text-sage-500">
                  {instructor.title}
                </p>
              )}
              {instructor.bio && (
                <p className="mt-3 text-sm text-sage-600 line-clamp-3">
                  {instructor.bio}
                </p>
              )}

              {/* Expertise tags */}
              {instructor.expertise && instructor.expertise.length > 0 && (
                <div className="mt-4 flex flex-wrap items-center justify-center gap-1.5">
                  {instructor.expertise.map((tag: string, ti: number) => (
                    <span
                      key={ti}
                      className="inline-block rounded-full bg-sage-50 px-2.5 py-0.5 text-xs font-medium text-sage-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
